import React from 'react';

import Loading from '../../Loading';
import useHeatmapData from './useHeatmapData';
import HeatmapView from './HeatmapView';

const HeatmapContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = useHeatmapData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <HeatmapView
      chartRef={chartRef}
      options={options ?? {}}
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default HeatmapContent;
